import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch, Link, useHistory } from "react-router-dom";

import AdminDashboard from "../Admin/AdminDashboard";
import Profile from "../Dashboard/Profile";
import CreateProperty from "../Dashboard/CreateProperty";
import ViewProperty from "../Dashboard/ViewProperty";
import TradeProperty from "../Dashboard/TradeProperty";
import Transactions from "../Dashboard/Transactions";
import BlockchainData from "../Admin/BlockchainData";
import Users from "../Admin/Users";
import RequestFund from "../Admin/RequestFund";
import AdminProperties from "../Admin/AdminProperties";
import EditProperty from "../Admin/EditProperty";
import AdminUserDetail from "../Admin/AdminUserDetail";
import Integrations from "../Admin/Integrations";
import IntegrationNafath from "../Admin/IntegrationNafath";
import IntegrationRER from "../Admin/IntegrationRER";
import IntegrationVirtualIBAN from "../Admin/IntegrationVirtualIBAN";
import FinanceManagement from "../Admin/FinanceManagement";
import FeeSettings from "../Admin/FeeSettings";
import WithdrawalManagement from "../Admin/WithdrawalManagement";
import PropertyEvaluations from "../Admin/PropertyEvaluations";
import PropertyExpenses from "../Admin/PropertyExpenses";
import QuarterlyReport from "../Admin/QuarterlyReport";
import UsersRoles from "../Admin/Settings/UsersRoles";
import SettingsPlaceholder from "../Admin/Settings/SettingsPlaceholder";
import AdminNews from "../Admin/AdminNews";
import AlinmaAdmin from "../Admin/AlinmaAdmin";
import AdminContactMessages from "../Admin/AdminContactMessages";

//admin layout component
const DashboardLayout = () => {
	let history = useHistory();
	const { auth } = useSelector((state) => state);
    useEffect(() => {
		if (!auth.data) {
			// Auth not yet resolved — wait for refreshToken to complete
			return;
		}
		const response = auth.data;
		if (response.status == 0) {
			history.push("/admin/login");
		} else if (!response.user || response.user.role != 1) {
			// Logged in but not an admin — send to home
			history.push("/");
		}
		window.scrollTo(0, 0);
    }, [auth]);
	return (
		<div>
		<Switch>
					<Route exact path="/admin/dashboard">
						<AdminDashboard />
					</Route>
					<Route exact path="/admin/profile">
						<Profile />
					</Route>
					<Route exact path="/admin/createproperty">
						<CreateProperty />
					</Route>
					<Route exact path="/admin/viewproperty/:id">
						<ViewProperty />
					</Route>
					<Route exact path="/admin/tradeproperty/:id">
						<TradeProperty />
					</Route>
					<Route exact path="/admin/transactions">
						<Transactions />
					</Route>
					<Route exact path="/admin/blockchaindata">
						<BlockchainData />
					</Route>
					<Route exact path="/admin/users">
						<Users />
					</Route>
					<Route exact path="/admin/requestFund">
						<RequestFund />
					</Route>
					<Route exact path="/admin/properties">
						<AdminProperties />
					</Route>
				<Route exact path="/admin/property/:id">
					<EditProperty />
				</Route>
				<Route exact path="/admin/user/:userId">
					<AdminUserDetail />
				</Route>
				{/* ── Integration Routes ── */}
				<Route exact path="/admin/integrations">
					<Integrations />
				</Route>
				<Route exact path="/admin/integrations/nafath">
					<IntegrationNafath />
				</Route>
				<Route exact path="/admin/integrations/rer">
					<IntegrationRER />
				</Route>
				<Route exact path="/admin/integrations/virtual-iban">
					<IntegrationVirtualIBAN />
				</Route>
				{/* ── Finance Routes ── */}
				<Route exact path="/admin/finance">
					<FinanceManagement />
				</Route>
				<Route exact path="/admin/fees">
					<FeeSettings />
				</Route>
				<Route exact path="/admin/withdrawals">
					<WithdrawalManagement />
				</Route>
				<Route exact path="/admin/evaluations/:propertyId">
					<PropertyEvaluations />
				</Route>
				<Route exact path="/admin/expenses/:propertyId">
					<PropertyExpenses />
				</Route>
				<Route exact path="/admin/report/:propertyId">
					<QuarterlyReport />
				</Route>
				{/* ── Settings Routes ── */}
				<Route exact path="/admin/settings/users">
					<UsersRoles />
				</Route>
				<Route exact path="/admin/settings/kyc">
					<SettingsPlaceholder title="KYC & Compliance" description="Manage KYC verification workflows and compliance rules." icon="🛡️" />
				</Route>
				<Route exact path="/admin/settings/notifications">
					<SettingsPlaceholder title="Notifications" description="Configure email and in-app notification templates and triggers." icon="🔔" />
				</Route>
				<Route exact path="/admin/settings/platform">
					<SettingsPlaceholder title="Platform Config" description="Global platform settings: branding, limits, and feature flags." icon="⚙️" />
				</Route>
				<Route exact path="/admin/settings/audit">
					<SettingsPlaceholder title="Audit Log" description="Full activity log of admin actions across the platform." icon="📋" />
				</Route>
				{/* ── News Routes ── */}
				<Route exact path="/admin/news">
					<AdminNews />
				</Route>
				{/* ── Alinma Virtual IBAN ── */}
				<Route exact path="/admin/alinma">
					<AlinmaAdmin />
				</Route>
				{/* ── Contact Messages ── */}
				<Route exact path="/admin/contact-messages">
					<AdminContactMessages />
				</Route>
			</Switch>
		</div>
	);
};

export default DashboardLayout;
